function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 11.9996,
    cy: 9.0001,
    r: 7.15,
    fill: "#F3F4F6",
    style: {
      fill: "#F3F4F6",
      fill: "color(display-p3 0.9529 0.9569 0.9647)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.596 14.4773C18.0487 13.2584 18.9576 11.5123 19.1229 9.62326C19.2882 7.73418 18.6962 5.85682 17.4773 4.40417C16.2584 2.95152 14.5123 2.04258 12.6233 1.87731C10.7342 1.71203 8.85682 2.30396 7.40417 3.52288L12.0001 9.0001L16.596 14.4773Z",
    fill: "#C0C0C0",
    style: {
      fill: "#C0C0C0",
      fill: "color(display-p3 0.7529 0.7529 0.7529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5963 19.7062L18.9675 14.0737C20.01 12.6487 20.625 10.8938 20.625 9C20.625 4.245 16.755 0.375 12 0.375C7.24502 0.375 3.37502 4.245 3.37502 9C3.37502 10.8938 3.99002 12.6487 5.03252 14.0737L2.40377 19.7062C2.28752 19.9575 2.31752 20.25 2.48627 20.4713C2.65127 20.6925 2.92502 20.805 3.19877 20.7638L6.71252 20.2275L8.56127 23.265C8.69627 23.49 8.94002 23.625 9.20252 23.625H9.24377C9.52127 23.61 9.76502 23.4412 9.88127 23.1937L12 18.6488L14.1188 23.1937C14.235 23.4412 14.4788 23.61 14.7563 23.625H14.7975C15.06 23.625 15.3038 23.49 15.4388 23.265L17.2875 20.2275L20.8013 20.7638C21.075 20.805 21.3488 20.6925 21.5138 20.4713C21.6825 20.25 21.7125 19.9575 21.5963 19.7062ZM12 16.125C8.07002 16.125 4.87502 12.93 4.87502 9C4.87502 5.07 8.07002 1.875 12 1.875C15.93 1.875 19.125 5.07 19.125 9C19.125 12.93 15.93 16.125 12 16.125Z",
    fill: "#C0C0C0",
    style: {
      fill: "#C0C0C0",
      fill: "color(display-p3 0.7529 0.7529 0.7529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15941 13.5V12.5455L12.1125 9.4858C12.4279 9.15341 12.6878 8.86222 12.8924 8.61222C13.0998 8.35937 13.2546 8.11932 13.3569 7.89205C13.4591 7.66477 13.5103 7.4233 13.5103 7.16761C13.5103 6.87784 13.4421 6.62784 13.3057 6.41761C13.1694 6.20455 12.9833 6.04119 12.7475 5.92756C12.5117 5.81108 12.2461 5.75284 11.9506 5.75284C11.6381 5.75284 11.3654 5.81676 11.1324 5.9446C10.8995 6.07244 10.7205 6.25284 10.5955 6.4858C10.4705 6.71875 10.408 6.99148 10.408 7.30398H9.15089C9.15089 6.77273 9.27305 6.30824 9.51737 5.91051C9.76168 5.51278 10.0969 5.20455 10.523 4.9858C10.9492 4.7642 11.4336 4.65341 11.9762 4.65341C12.5245 4.65341 13.0074 4.76278 13.425 4.98153C13.8455 5.19744 14.1736 5.4929 14.4094 5.8679C14.6452 6.24006 14.7631 6.66051 14.7631 7.12926C14.7631 7.45312 14.702 7.76989 14.5799 8.07955C14.4605 8.3892 14.2517 8.73437 13.9534 9.11506C13.6551 9.4929 13.2404 9.9517 12.7091 10.4915L10.9748 12.3068V12.3707H14.9037V13.5H9.15941Z",
    fill: "#6B7280",
    style: {
      fill: "#6B7280",
      fill: "color(display-p3 0.4196 0.4471 0.5020)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverBadge);
export default __webpack_public_path__ + "static/media/SilverBadge.841ae074d82861ede46a7a53359c832e.svg";
export { ForwardRef as ReactComponent };